import React from 'react';
import { Link } from 'react-router-dom';
import { PartnerRegistration } from '../components/PartnerRegistration';
import { ArrowRight } from 'lucide-react';

export const Partner: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="flex justify-center mb-6">
            <Link to="/partner" className="bg-indigo-50 text-indigo-600 px-6 py-2 rounded-full text-xs font-black uppercase tracking-widest flex items-center gap-2 hover:bg-indigo-100 transition-all">
              Sudah Punya Akun Mitra? Masuk Portal <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <span className="text-indigo-600 font-black uppercase tracking-[.3em] text-xs">B2B Partnership</span>
          <h1 className="text-4xl md:text-6xl font-black text-slate-900 mt-4 tracking-tighter">Mitra & Rombongan</h1>
          <p className="text-slate-500 mt-6 max-w-2xl mx-auto text-lg leading-relaxed">
            Platform khusus untuk institusi pendidikan, travel agent, dan korporasi untuk manajemen kunjungan grup.
          </p>
        </div>
      </div>
      <PartnerRegistration />
    </div>
  );
};
